// extracted by mini-css-extract-plugin
module.exports = {"header":"header_7wjx1","headerTitle":"headerTitle_dv74p"};